import React, { useState, useEffect } from "react";
import moment from "moment";
import "./weekcalendar.css";

export const WeekCalendar = () => {
  const [currentWeek, setCurrentWeek] = useState([]);

  useEffect(() => {
    // Get the current Monday
    const currentMonday = moment().startOf("week");

    // Create an array of days from Monday to Sunday
    const week = Array.from({ length: 7 }, (_, i) => {
      return moment(currentMonday)
        .add(i, "days")
        .format("dddd, MMMM Do");
    });

    setCurrentWeek(week);
  }, []);

  return (
    <>
      <div className="calendar-container">
        <table>
          <thead>
            <tr>
              {currentWeek.map((day, i) => (
                <th key={i}>{day}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 15 }, (_, i) => {
              return (
                <tr key={i}>
                  {currentWeek.map((_, j) => (
                    <td key={j}>{`${i + 7}:00`}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default WeekCalendar;